import React, { Component } from 'react';
import DisplayViewing from './display_viewing';
import ConfirmButton from './confirm_button';
import SubmitError from '~/components/book_viewing/submit_error';
import I18n from '~/utils/translations';

export default class ConfirmTimeslot extends Component {
  render() {
    if (this.props.submitted) {
      return (
        <section id="confirm" className="book-a-viewing-event__confirm">
          <DisplayViewing
            title={this.confirmationCopy}
            fullAddress={this.props.propertyAddress}
            datetime={this.props.datetime}
            property={this.props.property}
          />
        </section>
      );
    } else {
      return (
        <section id="confirm" className="book-a-viewing-event__confirm">
          <DisplayViewing
            title={this.viewingCopy}
            fullAddress={this.props.propertyAddress}
            datetime={this.props.datetime}
            confirm={true}
            property={this.props.property}
          >
            {this.props.children}
            <ConfirmButton
              viewingEvent={this.props.viewingEvent}
              property={this.props.property}
              loading={this.props.loading}
              disabled={this.props.disabled}
              onClick={this.props.onConfirm}
            />
            {!this.props.submitting && this.props.submitError && <SubmitError errorMessage={this.props.submitError} />}
          </DisplayViewing>
        </section>
      );
    }
  }

  get confirmationCopy() {
    return this.props.property.requestViewingEnabled
      ? I18n.t('viewings.viewing_is_requested')
      : I18n.t('viewings.viewing_is_booked');
  }

  get viewingCopy() {
    return this.props.property.requestViewingEnabled
      ? I18n.t('viewings.your_request')
      : I18n.t('viewings.your_viewing');
  }
}
